import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Formik
import { useFormikContext } from 'formik';
// Elements
import Label from '../elements/Label';
import Error from '../elements/Error';
const inputTypes = {
  website: 'url'
};
const WebsiteField = ({ formik = {}, hasError = false, fieldId, data }) => {
  const { handleChange, handleBlur, values } = useFormikContext();
  const type = data.type.toLowerCase();
  // Conditional logic
  if (data.conditionalLogic) {
    // Whether or not to show the field
    if (data.conditionalLogic.actionType === 'SHOW') {
      let show = true;
      data.conditionalLogic.rules.forEach((rule) => {
        if (rule.operator === 'IS') {
          if (values[`input_${rule.fieldId}`] !== rule.value) {
            show = false;
          }
        }
        if (rule.operator === 'IS_NOT') {
          if (values[`input_${rule.fieldId}`] === rule.value) {
            show = false;
          }
        }
      });
      if (!show) {
        return null;
      }
    }
  }
  return _jsxs("div", { className: `form-duuf-group form-duuf-group-${type}${data.cssClass ? ` ${data.cssClass}` : ''}`, children: [_jsx(Label, { fieldId: fieldId, data: data }), _jsx(Error, { fieldId: fieldId, data: data, hasError: hasError, formik: formik }), _jsx("input", { className: `form-duuf-input form-duuf-input-${type}`, type: inputTypes[type] || type, id: fieldId, name: fieldId, placeholder: data.placeholder, onBlur: handleBlur, onChange: handleChange, value: values[fieldId], maxLength: data.maxLength === 0 ? undefined : data.maxLength })] });
};
export default WebsiteField;